// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hzJ1","buttons":"styles_buttons__1Jz_8"};